import { useEffect, useRef, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import { Fragment } from "react/jsx-runtime";
import { getCurrentTime } from "./utils"
import { StyledButton } from "./utilsUi";
import { CustomScrollableTooltip, MenuPopOverContent } from "./CustomScrollableTooltip";

const TooltipTextForButton = ({ textValue, buttonComponent, limit, width }) => {
  return (
    <CustomScrollableTooltip title={<MenuPopOverContent MenuPopoverData={<Typography sx={{ fontSize: '1em' }}>{textValue}</Typography>} />} width={width}>
      {buttonComponent}
    </CustomScrollableTooltip>
  )
}

export const SessionTimer = ({
  expiry,
  signout,
  refreshSession,
  showDialogueTimer,
  handleCloseDialogueTimer
}) => {
  const [time, setTime] = useState(getCurrentTime(expiry));
  const intervalRef = useRef(null);
  useEffect(() => {
    intervalRef.current = setInterval(() => {
      const expiryDate = new Date(expiry);
      const now = new Date();
      const diff = expiryDate - now;

      if (diff <= 0) {
        clearInterval(intervalRef.current);
        handleSignOutSession();
      } else {
        setTime(getCurrentTime(expiry));
      }
    }, 1000);

    return () => clearInterval(intervalRef.current);
  });


  const handleSignOutSession = () => {
    clearInterval(intervalRef.current);
    handleCloseDialogueTimer();
    signout();
  };

  const handleStaySignIn = () => {
    clearInterval(intervalRef.current);
    handleCloseDialogueTimer();
    refreshSession();
  };

  return (
    <Dialog
      open={showDialogueTimer}
      onClose={handleCloseDialogueTimer}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <span style={{fontWeight: 'bold'}}>"Warning !"</span>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          You have been inactive for a while. For security reasons, you will be logged out in <span style={{ fontWeight: "bold" }}>{time}</span>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <StyledButton onClick={handleSignOutSession}>Signout</StyledButton>
        <TooltipTextForButton buttonComponent={<StyledButton onClick={handleStaySignIn}>Continue</StyledButton>} textValue="continue to stay signed in" />
      </DialogActions>
    </Dialog>
  );
};
